import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FiCreditCard } from "react-icons/fi";
import CrudEditPage from "../../../components/crud/CrudEditPage";
import FormGrid, { FormField } from "../../../components/crud/FormGrid";
import { accounts } from "../../utils/accountConstants";

const AddAccountBalance = () => {
	const [data, setData] = useState({ account: "", value: "", date_edited: "" });
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();

	const handleChange = (e) => {
		setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		try {
			await axios.post(`${process.env.REACT_APP_BACKEND_URL}/money`, data);
			navigate("/accountBalance");
		} catch (err) {
			console.log(err);
		} finally {
			setLoading(false);
		}
	};

	return (
		<CrudEditPage
			title="Add Account Balance"
			backLink="/accountBalance"
			backLabel="Back to Balances"
			breadcrumb={[
				{ label: "Money", to: "/lavella-dashboard" },
				{ label: "Account Balances", to: "/accountBalance" },
				{ label: "Add" },
			]}
			onSubmit={handleSubmit}
			submitLabel="Add Balance"
			isLoading={loading}
			variant="v4"
			icon={<FiCreditCard />}
		>
			<FormGrid>
				<FormField label="Account" name="account" width="half" required>
					<select name="account" id="account" value={data.account} onChange={handleChange} required>
						<option value="">Select an account</option>
						{accounts.map((account) => (
							<option key={account.account} value={account.account}>
								{account.account}
							</option>
						))}
					</select>
				</FormField>

				<FormField label="Value ($)" name="value" width="half" required>
					<input
						type="number"
						name="value"
						id="value"
						placeholder="0.00"
						value={data.value}
						onChange={handleChange}
						step="0.01"
						required
					/>
				</FormField>
			</FormGrid>
		</CrudEditPage>
	);
};

export default AddAccountBalance;
